<template>
  <div class="col-12 connections py-4 mb-4">
    <template v-if="connections?.length">
      <div class="filter-container d-flex align-items-center my-4">
        <label for="type-filter">Тип</label>
        <select
          id="type-filter"
          class="form-select w-auto ms-4"
          v-model="selectedType"
        >
          <option value="Все">Все</option>
          <option value="Действует">Действующая</option>
          <option value="Ликвидирована">Ликвидирована</option>
          <option value="Не действует">Не действующая</option>
        </select>
      </div>
      <div class="connections-list-container">
        <div
          class="connections-list"
          v-for="(company, index) in filteredOrganizations"
          :key="index"
        >
          <div class="connections-list__header">
            <h4 v-if="company?.inn">
              <a
                href="#"
                class="btn-link"
                @click.prevent="goToCompany(company.inn)"
              >
                {{ company.name }}
              </a>
            </h4>
            <h4 v-else>{{ company.name }}</h4>
            <span class="status" :class="getClass(company.status)">{{
              company.status
            }}</span>
          </div>
          <div class="connections-list__body">
            <p class="address">
              {{ company.legal_address }}
            </p>
            <p class="details">
              <span>ИНН: </span>{{ company.inn }} | <span>ОГРН: </span
              >{{ company.ogrn }} | <span>Дата регистрации: </span
              >{{ formatDate(company.registration_date) }} |
            </p>
            <p class="activity">
              <span>Основной вид деятельности:</span>
              {{ company.okved }}
            </p>
          </div>
        </div>
      </div>
    </template>
    <template v-else><p class="text-center">Нет данных</p> </template>
  </div>
</template>
<script>
import { defineComponent, ref, computed } from "vue";
import { useRouter } from "vue-router";
import moment from "moment";

export default defineComponent({
  name: "ConnectionOrgs",
  props: {
    connections: Array,
  },
  setup(props) {
    const router = useRouter();
    const selectedType = ref("Все");
    const filteredOrganizations = computed(() => {
      if (selectedType.value === "Все") {
        return props.connections;
      } else if (
        selectedType.value === "Действует" ||
        selectedType.value === "Не действует"
      ) {
        return props.connections.filter(
          (org) => org.status === selectedType.value
        );
      } else {
        return props.connections.filter(
          (org) => org.status !== "Действует" && org.status !== "Не действует"
        );
      }
    });

    const goToCompany = (inn) => {
      router.push("/counter-parties/" + inn);
    };

    const getClass = (status) => {
      if (status === "Действует") {
        return "active";
      } else if (status === "Не действует") {
        return "inactive";
      } else {
        return "liquidated";
      }
    };

    const formatDate = (date) => {
      return moment(date).format("DD.MM.YYYY");
    };

    return {
      selectedType,
      filteredOrganizations,
      getClass,
      goToCompany,
      formatDate,
    };
  },
});
</script>
